import React, { useEffect } from "react";

const socialLinks = [
  {
    href: "https://www.linkedin.com/company/72067539",
    img: "https://us-as.gr-cdn.com/images/common/templates/messages/v2/social/linkedin4.png",
    alt: "LinkedIn",
  },
  {
    href: "https://www.youtube.com/@SSTAiSolutions",
    img: "https://us-as.gr-cdn.com/images/common/templates/messages/v2/social/youtube4.png",
    alt: "YouTube",
  },
  {
    href: "https://www.instagram.com/shri_saitech/",
    img: "https://us-as.gr-cdn.com/images/common/templates/messages/v2/social/instagram4.png",
    alt: "Instagram",
  },
  {
    href: "https://www.facebook.com/NJShriSaiTechnology/",
    img: "https://us-as.gr-cdn.com/images/common/templates/messages/v2/social/facebook4.png",
    alt: "Facebook",
  },
  {
    href: "https://x.com/ShriSaiTech1",
    img: "https://us-as.gr-cdn.com/images/common/templates/messages/v2/social/twitter4.png",
    alt: "X",
  },
];

const LlminsightSaas = () => {
  useEffect(() => {
    // Remove background when component mounts
    document.body.style.background = "none";
    document.body.style.backgroundColor = "white";

    // Restore background when component unmounts
    return () => {
      document.body.style.background =
        "url('../public/bg_new.png') no-repeat center center fixed";
      document.body.style.backgroundSize = "cover";
      document.body.style.backgroundColor = "";
    };
  }, []);

  return (
    <div
      style={{
        backgroundColor: "#FFFFFF",
        fontFamily: "Arial, Ubuntu, Helvetica, sans-serif",
        maxWidth: 900,
        margin: "0 auto",
        padding: 5,
      }}
    >
      {/* Responsive Header Row */}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 10,
          gap: 10,
          flexWrap: "wrap",
        }}
      >
        <div style={{ flex: "0 0 99px", minWidth: 0, textAlign: "left" }}>
          <a href="http://sstus.net" target="_blank" rel="noopener noreferrer">
            <img
              src="https://us-ms.gr-cdn.com/getresponse-JEBmy/photos/d8a3e928-163a-4a42-8e19-1b0b8622b1ff.jpeg"
              alt="SST Logo"
              style={{
                width: "99px",
                maxWidth: "100%",
                height: "auto",
                display: "block",
              }}
            />
          </a>
        </div>
        <div
          style={{
            flex: "1 1 180px",
            minWidth: 0,
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <p style={{ fontSize: 12, margin: 0 }}>
            <a
              href="https://llminsight.ai/register"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#467886", textDecoration: "none" }}
            >
              <strong>
                <u>Register</u>
              </strong>
            </a>
            <span style={{ color: "#FF0000" }}>
              <strong>&nbsp;and get $5 Credit.</strong>
            </span>
            <br />
            <span style={{ color: "#FF0000" }}>
              <strong>Use this </strong>
            </span>
            <a
              href="https://llminsight.ai/register"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#467886", textDecoration: "none" }}
            >
              <strong>
                <u>$5 Credit</u>
              </strong>
            </a>
            <span style={{ color: "#FF0000" }}>
              <strong>&nbsp;to query any LLM Module using</strong>
            </span>
            <br />
            <a
              href="https://llminsight.ai/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#467886", textDecoration: "none" }}
            >
              <strong>
                <u>LLMInsight.ai</u>
              </strong>
            </a>
          </p>
        </div>
        <div style={{ flex: "0 0 71px", minWidth: 0, textAlign: "right" }}>
          <a
            href="http://llminsight.ai"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://us-ms.gr-cdn.com/getresponse-JEBmy/photos/58861e32-aa9a-45eb-90da-9f47f1922ae2.png"
              alt="LLMInsight Logo"
              style={{
                width: "71px",
                maxWidth: "100%",
                height: "auto",
                borderRadius: 25,
                display: "block",
              }}
            />
          </a>
        </div>
      </div>

      <div style={{ padding: 10, textAlign: "left" }}>
        <p>
          <strong>Hello,</strong>
        </p>
        <p>
          We would like to introduce to you&nbsp;
          <a
            href="https://llminsight.ai/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#3D40C6", textDecoration: "none" }}
          >
            LLMInsight.ai
          </a>
          &nbsp;an enterprise-focused platform for LLM governance, cost
          management, and unified access.&nbsp;
          <a
            href="https://llminsight.ai/register"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#3D40C6", textDecoration: "none" }}
          >
            Free to Sign up
          </a>
          &nbsp;and you get $5 Credit which you can use across different LLM
          models to test your application.
        </p>
        <p>
          <strong>Main Goal</strong>: To provide organizations with control,
          visibility, and cost optimization for their LLM usage across different
          departments and projects.
        </p>
        <p>
          <strong>Key Features</strong>: Centralized management of multiple LLM
          providers, real-time cost tracking with chargeback capabilities,
          robust governance features (like Azure AD integration and compliance),
          and unified interaction for end-users.
        </p>
        <p>
          <strong>Target Audience</strong>: Enterprises, IT departments, and
          business leaders who need to manage LLM consumption, ensure
          compliance, and control spending at an organizational level.
        </p>
        <p>
          <strong>Unified Chat Interface</strong> – Access and interact with
          multiple LLMs through a single, streamlined chat window for a seamless
          user experience.
        </p>
        <p>
          <strong>Supported AI Model Providers - </strong>
          Discover our extensive support for leading AI model providers,
          including OpenAI, GCP, AWS, and Perplexity and many more.&nbsp;
          <a
            href="https://llminsight.ai/providers"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#3D40C6", textDecoration: "none" }}
          >
            Click the link
          </a>
          &nbsp;to learn more about how we can enhance your AI capabilities with
          these partners
          <br />
          <br />
          <div style={{ fontSize: 16, textAlign: "center", margin: "16px 0" }}>
            <a
              href="https://llminsight.ai/"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#3D40C6",
                textDecoration: "none",
                fontWeight: "bold",
              }}
            >
              LLMInsight.ai
            </a>
            &nbsp;SaaS model One Pager with Architecture
          </div>
        </p>
      </div>

      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          // margin: "20px 0",
        }}
      >
        <a
          href="https://stllminsightdev.blob.core.windows.net/llminsight-data/LLMinsight-SaaS-One%20Pager_architecture.jpg?sp=r&st=2025-08-12T07:02:36Z&se=2027-12-31T15:17:36Z&sv=2024-11-04&sr=b&sig=3nREvjLI2qlucmrr%2BMt8xd07Hz7Q2UYkY5euVfaLHO4%3D"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://us-ms.gr-cdn.com/getresponse-JEBmy/photos/47d5a425-21b1-43f1-9200-7e0c1131e769.jpg"
            alt="LLMInsight SaaS Architecture"
            style={{ width: "100%", maxWidth: 590, display: "block" }}
          />
        </a>
      </div>

      <div style={{ padding: 10, textAlign: "justify" }}>
        <p>
          <a
            href="https://llminsight.ai/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#3D40C6", textDecoration: "none" }}
          >
            LLMInsight.ai
          </a>
          &nbsp;is also available in IaaS model. Please visit the&nbsp;
          <a
            href="https://aws.amazon.com/marketplace/pp/prodview-xlkqdas262mda"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#3D40C6", textDecoration: "none" }}
          >
            AWS
          </a>
          ,&nbsp;
          <a
            href="https://console.cloud.google.com/marketplace/product/sst-public/llminsight.ai?"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#3D40C6", textDecoration: "none" }}
          >
            GCP
          </a>
          &nbsp;or&nbsp;
          <a
            href="https://azuremarketplace.microsoft.com/en-us/marketplace/apps/shrisaitechllc1657565263846.constingapp?tab=Overview"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#3D40C6", textDecoration: "none" }}
          >
            Azure
          </a>
          &nbsp;Marketplace. In IaaS model bring your own LLM Modules, own your
          data and manage LLM modules, visibility, and cost optimization for
          their LLM usage across different departments and projects.
          <br />
          <br />
          Regards,
          <br />
          LLM Insight Sales Team.
          <br />
          {/* Social Media Icons */}
          <span style={{ display: "inline-flex", gap: 8, margin: "8px 0" }}>
            {socialLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                style={{ display: "inline-block" }}
              >
                <img
                  src={link.img}
                  alt={link.alt}
                  style={{
                    width: 30,
                    height: 30,
                    borderRadius: 0,
                    display: "block",
                  }}
                />
              </a>
            ))}
          </span>
          <br />
          <a
            href="mailto:sstsupport@sstglobal.net"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#3D40C6", textDecoration: "none" }}
          >
            sstsupport@sstglobal.net
          </a>
          <br />
          <a
            href="https://sstus.net/"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#3D40C6",
              textDecoration: "none",
              fontWeight: 400,
            }}
          >
            <u>SST (Shri Sai Tech LLC)</u>
          </a>
        </p>
      </div>

      <div style={{ textAlign: "center", fontSize: 12, margin: "20px 0" }}>
        SST, 7 Preservation Dr. Monroe New Jersey, North Brunswick, NJ 08902,
        United States of America
        <br />
        <br />
        You may{" "}
        <a
          href="https://app.getresponse.com/unsubscribe.html?x=a62b&co=E&m=E&mc=JT&u=JEBmy&z=Ew38MCP&"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#10BCF9" }}
        >
          unsubscribe
        </a>{" "}
        or{" "}
        <a
          href="https://app.getresponse.com/change_details.html?x=a62b&co=E&m=E&u=JEBmy&z=EGeZwNQ&"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#10BCF9" }}
        >
          change your contact details
        </a>{" "}
        at any time.
      </div>

      <div
        style={{ textAlign: "center", fontSize: 10, paddingBottom: 20 }}
      ></div>
    </div>
  );
};

export default LlminsightSaas;
